// Helper function to map actual width to price data width format
// Actual widths (18, 24, 30) map to price data widths (17" WIDE, 23" WIDE, 29" WIDE)
function mapWidthToPriceDataWidth(width) {
  const widthMap = {
    18: "17",
    24: "23",
    30: "29",
  };
  return widthMap[String(width)] || width;
}

class collapsableItem {
  constructor(element) {
    this.element = element;
    this.toggleIcon = this.element.querySelector(".mc-collapse-state");
    this.toggleSpace = this.element.querySelector(".mc-collapse-tower-wrapper");
    this.settingsWrapper = this.element.querySelector(".mc-tower-properties");
  }

  minimizeTower() {
    // const element = this instanceof HardwareSetting ? this.element : this.tower;
    this.toggleIcon.classList.remove("mc-collapse-state-expanded");
    this.toggleIcon.classList.add("mc-collapse-state-minimized");
    this.element.classList.remove("mc-tower-expanded");
    this.element.classList.add("mc-tower-minimized");
    this.settingsWrapper.classList.remove("mc-tower-properties-expanded");
    this.settingsWrapper.classList.add("mc-tower-properties-minimized");
  }

  expandTower() {
    // const element = this instanceof HardwareSetting ? this.element : this.tower;
    this instanceof Tower && (document.CabinetVars.SelectedIndex = this.towerCounter - 1);
    // Open doors when expanding a tower (so user can see inside)
    if (this instanceof Tower && this.doorOptions && this.doorOptions.selectedValue !== "none") {
      this.doorOptions.openDoors();
    }
    this.toggleIcon.classList.remove("mc-collapse-state-minimized");
    this.toggleIcon.classList.add("mc-collapse-state-expanded");
    this.element.classList.remove("mc-tower-minimized");
    this.element.classList.add("mc-tower-expanded");
    this.settingsWrapper.classList.remove("mc-tower-properties-minimized");
    this.settingsWrapper.classList.add("mc-tower-properties-expanded");
  }

  toggleTower(_this) {
    _this = _this || this;
    if (_this.toggleIcon.classList.contains("mc-collapse-state-expanded")) {
      _this.minimizeTower();
    } else {
      this.towersArray?.forEach(tower => {
        if (tower !== this) {
          tower.minimizeTower();
        }
      });
      this.expandTower();
    }
  }

  removeEventListeners() {
    this.toggleSpace.removeEventListener("click", this._toggleHandler);
  }

  initToggleIcon() {
    let _this = this;
    this._toggleHandler = () => this.toggleTower(_this);
    this.toggleSpace.addEventListener("click", this._toggleHandler);
  }
}
class Tower extends collapsableItem {
  constructor(towerCounter, towersArray, selectedOptions, prices, color) {
    super(document.querySelector(`#t${towerCounter}`));
    this.towersArray = towersArray;
    this.towerCounter = towerCounter;
    this.tower = document.querySelector(`#t${towerCounter}`);
    this.tower.querySelector(".mc-tower-label").innerText = "Tower    " + towerCounter;
    this.toggleIcon = this.tower.querySelector(".mc-collapse-state");
    this.toggleSpace = this.tower.querySelector(".mc-collapse-tower-wrapper");
    this.settingsWrapper = this.tower.querySelector(".mc-tower-properties");
    this.settings = this.tower.querySelectorAll(".mc-setting");
    this.settingToggles = [];
    this.trashIcon = this.tower.querySelector(".mc-trash-icon");
    this.price = 0;
    this.hasDoors = 0;
    this.pricesArray = prices;
    if (towerCounter == 1) {
      this._totalPrice = this.createObservableVariable();
      this._totalDoors = this.createObservableVariable();
      this._hasClosedDoors = this.createObservableVariable();
      this._color = this.createObservableVariable(new ColorSetting(color || "WHITE", this));
      this._hardwareSetting = this.createObservableVariable(new HardwareSetting(this));
      // this._hasOpenDoors = this.createObservableVariable();
    }
    this.variants = [];
    this.selectedOptions = selectedOptions;
    this.width = new WidthSetting(this.settings[0], this);
    this.topOptions = new TopSetting(this.settings[1], towerCounter, this);
    this.bottomOptions = new BottomSetting(this.settings[2], towerCounter, this);
    this.drawerHardwareOptions = new DrawerHardware(towerCounter, this);
    this.doorOptions = new DoorSetting(this.settings[3], towerCounter, this);
    this.doorHardwareOptions = new DoorHardware(towerCounter, this);
    this.shelfHangingVariant = {};
    this.shelfHangingVariantPrice = 0;
    this.initTower();
  }

  updateOptionsToWidth(width) {
    this.price -= this.shelfHangingVariantPrice;
    this.totalPrice -= this.shelfHangingVariantPrice;
    this.variants.pop();
    this.variants.push(
      this.shelfHangingVariant.types.find(t => {
        return (
          t.option1.toUpperCase() == this.color &&
          t.option3.startsWith("22") &&
          t.option2.startsWith(width)
        );
      })
    );
    // For first tower, shelf is at index 2 (after the two side panels)
    // For other towers, shelf is at index 1 (after the center panel)
    const shelfIndex = this.towerCounter == 1 ? 2 : 1;
    this.shelfHangingVariantPrice = this.variants[shelfIndex]?.price || 0;
    this.price += this.shelfHangingVariantPrice;
    this.totalPrice += this.shelfHangingVariantPrice;
  }

  // updatePriceByColor() {
  // 	this.totalPrice -= this.shelfHangingVariantPrice;
  // 	this.variants.pop();
  // 	this.variants.push(
  // 		this.shelfHangingVariant.types.find((t) => {
  // 			return t.option1.toUpperCase() == this.color && t.option3.startsWith('22') && t.option2.startsWith(width)
  // 		})
  // 	);
  // 	this.shelfHangingVariantPrice = this.variants[1].price;
  // 	this.totalPrice += this.shelfHangingVariantPrice;
  // }
  get hardwareSetting() {
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    return target._hardwareSetting.value;
  }

  get color() {
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    return target._color.value.color;
  }

  get totalPrice() {
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    return target._totalPrice.value;
  }

  set totalPrice(value) {
    if (value >= 0) {
      document.isChanged = true;
      let target = this.towerCounter === 1 ? this : this.towersArray[0];
      target._totalPrice.value = value;
      // DOM manipulations
      let checkoutTotal = document.querySelectorAll(".mc-checkout-total");

      checkoutTotal.forEach(ct => {
        ct.innerText = `$${(value / 100).toFixed(2)}`;
      });

      const checkoutBtnTexts = document.querySelectorAll(".mc-checkout-btn-text");
      checkoutBtnTexts.forEach(checkoutBtnText => {
        const totalSpan = checkoutBtnText.querySelector("span");
        if (totalSpan) {
          totalSpan.innerText = `$${(value / 100).toFixed(2)}`;
        }
      });

      let draftTotalAmountText = document.getElementById("draft-total-amount");
      if (draftTotalAmountText) {
        draftTotalAmountText.innerText = (value / 100).toFixed(2);
      }
      let discountedTotalDiv = document.querySelector(".discounted-price .discounted-value");
      if (discountedTotalDiv) {
        discountedTotalDiv.textContent = (value / 100).toFixed(2);
      }

      discountPercent && updateDiscount();
    }
  }

  get totalDoors() {
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    return target._totalDoors.value;
  }

  set totalDoors(value) {
    // console.log("set totaldoors", value);
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    target._totalDoors.value = value;
  }

  get hasClosedDoors() {
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    return target._hasClosedDoors.value;
  }

  set hasClosedDoors(value) {
    // console.log("set hasClosedDoors", value, getToggleDoorsState());
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    target._hasClosedDoors.value = value;
    if (value == 0 && getToggleDoorsState() == "Open Doors") {
      toggleDoors();
    } else {
      if (this.towersArray.length) {
        let hasOpenDoors = this.towersArray.find(t => {
          t.doorOptions.doorState === "open";
        });
        if (!hasOpenDoors && getToggleDoorsState() == "Close Doors") {
          toggleDoors();
        }
      }
    }
  }

  initTower() {
    this.initPrice();
    this.addTowerToCanvas();
    this.initToggleIcon();
    this.initTrashIcon();
    this.initSettingToggles();
    this.setDefaultObjects();
  }

  initPrice() {
    this.totalPrice -= this.price;
    this.price = 0;
    this.variants = [];
    if (this.towerCounter == 1) {
      let price = this.pricesArray.find(priceItem => {
        return priceItem.title == "alto-side-panel-pack";
      });
      // Add two side panel packs since each pack only contains 1 panel
      this.variants[0] = price.types.find(t => {
        return t.option1.toUpperCase() == this.color && t.option2 == '22" DEEP';
      });
      this.variants[1] = price.types.find(t => {
        return t.option1.toUpperCase() == this.color && t.option2 == '22" DEEP';
      });
      this.price = this.variants[0].price + this.variants[1].price;
    } else {
      let price = this.pricesArray.find(priceItem => {
        return priceItem.title == "alto-center-panel-pack";
      });
      this.variants[0] = price.types.find(t => {
        return t.option1.toUpperCase() == this.color && t.option2 == '22" DEEP';
      });
      this.price = this.variants[0].price;
    }
    //add shelves default 30
    this.shelfHangingVariant = this.pricesArray.find(priceItem => {
      return priceItem.title === "alto-fixed-shelf-pack";
    });
    const shelfVariant = this.shelfHangingVariant.types.find(t => {
      return (
        t.option1.toUpperCase() == this.color &&
        t.option3.startsWith("22") &&
        t.option2.startsWith(this.width.selectedValue)
      );
    });
    if (!shelfVariant) {
      console.warn("[Verra] Shelf variant not found for width:", this.width.selectedValue, "mapped:", mapWidthToPriceDataWidth(this.width.selectedValue), "color:", this.color);
    }
    this.variants.push(shelfVariant);
    // For first tower, shelf is at index 2 (after the two side panels)
    // For other towers, shelf is at index 1 (after the center panel)
    const shelfIndex = this.towerCounter == 1 ? 2 : 1;
    this.shelfHangingVariantPrice = this.variants[shelfIndex]?.price || 0;
    this.price += this.shelfHangingVariantPrice;
    this.totalPrice += this.price;
    // console.log("init price on tower", this.towersArray, this.tower, this);
  }

  delete() {
    this.totalPrice -= this.price;
  }

  createObservableVariable(value) {
    let _value = value || 0;

    return {
      get value() {
        return _value;
      },
      set value(newValue) {
        _value = newValue;
      },
    };
  }
  setDefaultObjects() {
    if (this.selectedOptions) {
      const _pa = (label) => console.log(`[PriceAudit T${this.towerCounter}] ${label}: total=${this.totalPrice/100} base=${this.price/100} top=${this.topOptions.price/100} bot=${this.bottomOptions.price/100} door=${this.doorOptions.price/100} doorHW=${this.doorHardwareOptions.price/100} drawerHW=${this.drawerHardwareOptions.price/100}`);
      _pa(`START opts=${JSON.stringify(this.selectedOptions)}`);
      this.width.selectWidth(this.selectedOptions.width);
      _pa(`after selectWidth(${this.selectedOptions.width})`);
      // Set hardware settings first so rods use the correct color
      this.hardwareSetting.selectType(this.selectedOptions.hardwareType);
      this.hardwareSetting.selectColor(this.selectedOptions.hardwareColor);
      _pa(`after hardware type=${this.selectedOptions.hardwareType} color=${this.selectedOptions.hardwareColor}`);
      this.topOptions.selectOption(this.selectedOptions.topOption);
      _pa(`after topOptions(${this.selectedOptions.topOption})`);
      this.bottomOptions.isDefaultValue = false;
      this.bottomOptions.selectOption(this.selectedOptions.bottomOption);
      _pa(`after bottomOptions(${this.selectedOptions.bottomOption})`);
      // this.selectedOptions.doorHardwareType && this.doorHardwareOptions.selectTypeOption(this.selectedOptions.doorHardwareType);
      // this.selectedOptions.doorHardwareColor && this.doorHardwareOptions.selectColorOption(this.selectedOptions.doorHardwareColor);
      this.doorOptions.selectOption(this.selectedOptions.doorOption);
      _pa(`after doorOptions(${this.selectedOptions.doorOption})`);
      // Apply hardware settings if they exist and doors are present
      // if (this.selectedOptions.doorOption && this.selectedOptions.doorOption !== "none") {
      // 	// Clear any default hardware that may have been added
      // 	if (this.doorHardwareOptions.price > 0) {
      // 		// Remove whatever hardware was added (could be pulls or knobs)
      // 		try {
      // 			document.App.removeObjectFromSelectedCabinet("pull", this.towerCounter - 1);
      // 		} catch (error) {
      // 			// Ignore if not found
      // 		}
      // 		try {
      // 			document.App.removeObjectFromSelectedCabinet("knob", this.towerCounter - 1);
      // 		} catch (error) {
      // 			// Ignore if not found
      // 		}
      // 		// Reset price and variants without hiding the display
      // 		this.totalPrice -= this.doorHardwareOptions.price;
      // 		this.doorHardwareOptions.price = 0;
      // 		this.doorHardwareOptions.variants = [];
      // 	}
      // 	// Set hardware type and color properties directly, then apply once
      // 	if (this.selectedOptions.hardwareType) {
      // 		this.doorHardwareOptions.selectedType = this.selectedOptions.hardwareType;
      // 	}
      // 	if (this.selectedOptions.hardwareColor) {
      // 		this.doorHardwareOptions.selectedColor = this.selectedOptions.hardwareColor;
      // 	}
      // 	// Update the display and add hardware to canvas
      // 	if (this.selectedOptions.hardwareType && this.selectedOptions.hardwareColor) {
      // 		this.doorHardwareOptions.selectedValueElement.innerText = `${this.doorHardwareOptions.selectedType.charAt(0).toUpperCase() +
      // 			this.doorHardwareOptions.selectedType.slice(1)
      // 			} - ${this.doorHardwareOptions.selectedColor.charAt(0).toUpperCase() +
      // 			this.doorHardwareOptions.selectedColor.slice(1)
      // 			}`;
      // 		// Update radio button states to match the selected values
      // 		this.doorHardwareOptions.updateRadioButtons();
      // 		this.doorHardwareOptions.addOptionToCanvas();
      // 	}
      // }
    } else {
      this.topOptions.addOptionToCanvas();
      this.bottomOptions.addOptionToCanvas();
    }
    // console.log("towersArray", this.towersArray, this.towersArray.length);
  }
  addTowerToCanvas() {
    //redone
    if (this.towersArray.length < 1) {
      document.App.addBigWardrobeToScene("30/30W_TOWER", document.App.positions["30/30W_TOWER"]);
      // this.initColorSetting();
    } else {
      document.App.addAdditionalCabinet("30/30W_TOWER");
      document.CabinetVars.SelectedIndex = this.towerCounter - 1;
      this.hasDoors && this.towersArray[this.towersArray.length - 1].doorOptions.closeDoors();
      this.towersArray[this.towerCounter - 2].width.widthFixed = true;
    }
  }

  initSettingToggles() {
    this.settings.forEach(setting => {
      this.settingToggles.push(new SettingToggle(setting, this.settingToggles, this));
    });
  }

  initTrashIcon() {
    this.trashIcon.addEventListener("click", () => removeTower(this.towerCounter - 1));
  }

  // initColorSetting() {
  // 	let colorsWrapper = document.querySelector(".mc-color-options");
  // 	let colors = colorsWrapper.querySelectorAll("input");
  // 	colors.forEach(color => {
  // 		color.addEventListener("click", () => {
  // 			this.setColor();
  // 		});
  // 	});
  // 	if (this.color) {
  // 		colors.forEach(color => {
  // 			if (color.getAttribute("value") == this.color) {
  // 				color.checked = true;
  // 			}
  // 		});
  // 		this.setColor();
  // 	}
  // }

  // getSelectedColor() {
  // 	return document.querySelector(`input[name="color"]:checked`).value;
  // }
}

class ColorSetting {
  constructor(color, tower) {
    this.color = color;
    this.tower = tower;

    this.rootEl = this.getActiveRoot();
    this.options = this.rootEl
      .querySelector(".mc-color-options")
      .querySelectorAll('input[name="color"]');

    this.initColorSetting();
  }

  getActiveRoot() {
    const roots = [...document.querySelectorAll(".mc-color")];
    return roots.find(el => el.offsetParent !== null) || roots[0];
  }

  refreshRoot() {
    // call this before reading checked inputs, in case the visible UI swapped
    this.rootEl = this.getActiveRoot();
    this.options = this.rootEl
      .querySelector(".mc-color-options")
      .querySelectorAll('input[name="color"]');
  }

  selectColor(color) {
    document.querySelectorAll(".mc-color").forEach(root => {
      root.querySelectorAll('input[name="color"]').forEach(option => {
        option.checked = (option.value == color);
      });
    });
    this.refreshRoot();
    const activeRadio = this.rootEl.querySelector(`input[name="color"][value="${color}"]`);
    if (activeRadio) activeRadio.checked = true;
    this.setColor();
  }

  setColor() {
    this.refreshRoot();

    const checked = this.rootEl.querySelector(`input[name="color"]:checked`);
    if (!checked) return;

    const value = checked.value;
    this.color = value;

    const selectedColor = this.rootEl.querySelector(".mc-color-selected");
    if (selectedColor) {
      document.isChanged = selectedColor.innerText == value ? document.isChanged : true;
      selectedColor.innerText = value;
    }

    switch (value) {
      case "NATURAL OAK":
        document.App.material.color.set(0xe5d9bd);
        document.App.materialNoAO.color.set(0xe5d9bd);
        break;
      case "GREY":
        document.App.material.color.set(0x808080);
        document.App.materialNoAO.color.set(0x808080);
        break;
      case "WHITE":
      case "white":
        document.App.material.color.set(0xffffff);
        document.App.materialNoAO.color.set(0xffffff);
        break;
    }

    this.tower.towersArray.forEach(tower => {
      tower.initPrice();
      tower.topOptions.setColor(this.color);
      tower.bottomOptions.setColor(this.color);
      tower.doorOptions.setColor(this.color);
    });
  }

  initColorSetting() {
    if (this.color) {
      this.selectColor(this.color);
    }

    // bind listeners on BOTH UIs so whichever becomes visible works
    document.querySelectorAll(".mc-color").forEach(root => {
      root.querySelectorAll('input[name="color"]').forEach(option => {
        option.addEventListener("click", () => this.setColor());
      });
    });
  }
}


class HardwareSetting extends collapsableItem {
  constructor(tower) {
    super(document.querySelector("#hardware"));
    this.tower = tower;
    this.selectedType = "pulls";
    this.selectedColor = "chrome";
    this.settings = this.element.querySelectorAll(".mc-setting");
    this.settingToggles = [];
    this.typeOptions = this.settings[0]
      .querySelector(".mc-setting-options")
      .querySelectorAll(".mc-radio-item");
    this.displayType = this.settings[0].querySelector(".mc-selected-setting");
    this.colorOptions = this.settings[1]
      .querySelector(".mc-setting-options")
      .querySelectorAll(".mc-radio-item");
    this.displayColor = this.settings[1].querySelector(".mc-selected-setting");
    this.initHardwareSettings();
  }

  initHardwareSettings() {
    this.initToggleIcon();
    this.initSettingToggles();
    this.initOptions();
  }

  closeAllDoors() {
    // Helper method to close all doors before applying hardware changes
    if (this.tower && this.tower.towersArray) {
      const currentIndex = document.CabinetVars.SelectedIndex;
      this.tower.towersArray.forEach(tower => {
        if (tower.doorOptions && tower.doorOptions.selectedValue !== "none") {
          document.CabinetVars.SelectedIndex = tower.towerCounter - 1;
          tower.doorOptions.closeDoors();
        }
      });
      document.CabinetVars.SelectedIndex = currentIndex;
    }
  }

  removeEventListeners() {
    super.removeEventListeners();
    this.settingToggles.forEach(toggle => toggle.removeEventListeners());
  }

  selectColor(color) {
    this.selectedColor = color;
    this.displayColor.innerText = color.charAt(0).toUpperCase() + color.slice(1);
    this.colorOptions.forEach(option => {
      const value = option.querySelector("input").getAttribute("value");
      // Case-insensitive comparison to handle "Brass" vs "brass" etc.
      if (value.toLowerCase() === this.selectedColor.toLowerCase()) {
        option.querySelector("input").checked = true;
      } else {
        option.querySelector("input").checked = false;
      }
    });
  }

  selectType(type) {
    this.selectedType = type;
    this.displayType.innerText = type.charAt(0).toUpperCase() + type.slice(1);
    this.typeOptions.forEach(option => {
      const value = option.querySelector("input").getAttribute("value");
      if (value === this.selectedType) {
        option.querySelector("input").checked = true;
      } else {
        option.querySelector("input").checked = false;
      }
    });
  }

  initOptions() {
    this.typeOptions.forEach(option => {
      option.addEventListener("click", () => {
        this.setSelectedType(option.querySelector("input").getAttribute("value"));
      });
    });

    this.colorOptions.forEach(option => {
      option.addEventListener("click", () => {
        this.setSelectedColor(option.querySelector("input").getAttribute("value"));
      });
    });
  }

  setSelectedType(type) {
    this.selectedType = type;
    this.displayType.innerText = type.charAt(0).toUpperCase() + type.slice(1);
    this.updateHardwareTypeOnCanvas();
    // console.log("adina set selected hardware type", type);
  }

  setSelectedColor(color) {
    //drawers, doors and rods.
    this.selectedColor = color.charAt(0).toUpperCase() + color.slice(1);
    this.displayColor.innerText = color.charAt(0).toUpperCase() + color.slice(1);
    this.updateHardwareColorOnCanvas();
    // console.log("adina set selected hardware color", color);
  }

  updateHardwareTypeOnCanvas() {
    // Close all doors before applying hardware type changes
    this.closeAllDoors();
    //drawers and doors
    const index = document.CabinetVars.SelectedIndex;
    this.tower.towersArray.forEach(tower => {
      document.CabinetVars.SelectedIndex = tower.towerCounter - 1;
      tower.drawerHardwareOptions.setSelectedType();
      tower.doorHardwareOptions.setSelectedType();
    });
    document.CabinetVars.SelectedIndex = index;
  }

  updateHardwareColorOnCanvas() {
    // Close all doors before applying hardware color changes
    this.closeAllDoors();
    const index = document.CabinetVars.SelectedIndex;
    this.tower.towersArray.forEach(tower => {
      document.CabinetVars.SelectedIndex = tower.towerCounter - 1;
      ["short-hanging", "tall-hanging"].includes(tower.topOptions.selectedValue) &&
        tower.topOptions.addOptionToCanvas();
      ["hanging"].includes(tower.bottomOptions.selectedValue) &&
        tower.bottomOptions.addOptionToCanvas();
      // Update shoe shelves pricing when hardware color changes (shoe rails use hardware color)
      ["shoe-shelves"].includes(tower.topOptions.selectedValue) &&
        tower.topOptions.setColor(tower.color);
      ["shoe-shelves"].includes(tower.bottomOptions.selectedValue) &&
        tower.bottomOptions.setColor(tower.color);
      tower.drawerHardwareOptions.setSelectedColor();
      tower.doorHardwareOptions.setSelectedColor();
    });
    document.CabinetVars.SelectedIndex = index;
  }

  initSettingToggles() {
    this.settings.forEach(setting => {
      this.settingToggles.push(new SettingToggle(setting, this.settingToggles, this));
    });
  }

  expandTower() {
    // Close all doors when hardware settings are opened
    this.closeAllDoors();
    // Call parent expandTower method
    super.expandTower();
  }
}

class DoorHardware {
  constructor(towerCounter, tower) {
    this.towerCounter = towerCounter;
    this.tower = tower;
    // this.hardwareTypeOptions = doorHardwareSetting.querySelectorAll(".door-hardware-type");
    // this.hardwareColorOptions = doorHardwareSetting.querySelectorAll(".door-hardware-color");
    // this.selectedValueElement = doorHardwareSetting.querySelector(".mc-selected-setting");
    // this.selectedType = "pulls";
    // this.selectedColor = "black";
    this.variants = [];
    this.price = 0;
    // this.initDoorHardwareSetting();
  }

  // initDoorHardwareSetting() {
  // 	this.hardwareTypeOptions.forEach(option => {
  // 		option.querySelector("input").setAttribute("name", `door-hardware-type-${this.towerCounter}`);
  // 		const optionId = option.querySelector("input").getAttribute("id");
  // 		option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
  // 		option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
  // 		option.addEventListener("click", () =>
  // 			this.setSelectedType(option.querySelector("input").getAttribute("value"))
  // 		);
  // 	});
  // 	this.hardwareColorOptions.forEach(option => {
  // 		option
  // 			.querySelector("input")
  // 			.setAttribute("name", `door-hardware-color-${this.towerCounter}`);
  // 		const optionId = option.querySelector("input").getAttribute("id");
  // 		option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
  // 		option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
  // 		option.addEventListener("click", () =>
  // 			this.setSelectedColor(option.querySelector("input").getAttribute("value"))
  // 		);
  // 	});
  // }

  // selectTypeOption(type) {
  // 	this.selectedType = type;
  // 	this.setDisplayedValue();
  // 	// Update hardware type radio buttons
  // 	this.hardwareTypeOptions.forEach(option => {
  // 		const input = option.querySelector("input");
  // 		const value = input.getAttribute("value");
  // 		if (value === this.selectedType) {
  // 			input.checked = true;
  // 		} else {
  // 			input.checked = false;
  // 		}
  // 	});
  // }

  // selectColorOption(color) {
  // 	this.selectedColor = color;
  // 	this.setDisplayedValue();
  // 	// Update hardware color radio buttons
  // 	this.hardwareColorOptions.forEach(option => {
  // 		const input = option.querySelector("input");
  // 		const value = input.getAttribute("value");
  // 		if (value === this.selectedColor) {
  // 			input.checked = true;
  // 		} else {
  // 			input.checked = false;
  // 		}
  // 	});
  // }

  // setDisplayedValue() {
  // 	this.selectedValueElement.innerText = `${this.selectedType.charAt(0).toUpperCase() + this.selectedType.slice(1)
  // 		} - ${this.selectedColor.charAt(0).toUpperCase() + this.selectedColor.slice(1)}`;
  // }

  setSelectedType(value) {
    document.App.removeObjectFromSelectedCabinet("doorHardware", this.towerCounter - 1);
    // document.App.clearAllDoorHardwareForSelectedCabinet(this.towerCounter - 1);
    // this.selectedType = value;
    // this.setDisplayedValue();
    // this.updateRadioButtons();
    this.addOptionToCanvas();
  }

  setSelectedColor(value) {
    document.App.removeObjectFromSelectedCabinet("doorHardware", this.towerCounter - 1);
    // document.App.clearAllDoorHardwareForSelectedCabinet(this.towerCounter - 1);
    // this.selectedColor = value;
    // this.setDisplayedValue();
    // this.updateRadioButtons();
    this.addOptionToCanvas();
  }

  options = {
    pull: "PULL_MODERN",
    pulls: "PULL_MODERN",
    knob: "PULL_KNOB",
    knobs: "PULL_KNOB",
  };

  // typeMap = {
  // 	pull: "pull",
  // 	pulls: "pull",
  // 	knob: "knob",
  // 	knobs: "knob"
  // }

  addOptionToCanvas() {
    // Remove old hardware if it was added to the canvas
    // if (this.price > 0 && this.variants.length > 0) {
    // 	try {
    // 		let type =
    // 			this.selectedType.slice(-1) == "s" ? this.selectedType.slice(0, -1) : this.selectedType;
    // document.App.removeObjectFromSelectedCabinet(type, this.towerCounter - 1);
    // 	} catch (error) {
    // 		console.log("Old hardware not found to remove:", error);
    // 	}
    // }
    let selectedDoor = this.tower.doorOptions.selectedValue;
    if (selectedDoor != "none") {
      let width = this.tower.width.selectedValue;
      let doorObject = this.tower.doorOptions.objects[selectedDoor];
      let object = `${this.options[this.tower.hardwareSetting.selectedType]
        }_%_${this.tower.hardwareSetting.selectedColor.toUpperCase()}%`;
      doorObject.hardwarePositionsX.forEach((x, index) => {
        let hardwareObject = object.replace("%", x);
        let suffix = doorObject.hardwarePositionsY[index];
        let extraName = hardwareObject.replace("%", suffix);
        hardwareObject = hardwareObject.replace("%", "");
        document.App.addObjectToSelectedCabinet(
          hardwareObject,
          extraName,
          `${width}/${width}W_TOWER`,
          "doorHardware"
        );
      });
      this.tower.totalPrice -= this.price;
      this.variants = []; // Clear old variants before adding new one
      const priceItem = this.tower.pricesArray.find(item => {
        return ["pull", "pulls"].includes(this.tower.hardwareSetting.selectedType)
          ? item.title == "alto-modern-pull"
          : item.title == "alto-modern-knob";
      });
      console.log("priceItem", priceItem, "selectedType", this.tower.hardwareSetting.selectedType);
      if (!priceItem) {
        console.error(
          "Price item not found for hardware type:",
          this.tower.hardwareSetting.selectedType
        );
        return;
      }
      // Normalize color for matching - handle case differences
      let colorToMatch = this.tower.hardwareSetting.selectedColor.toUpperCase().trim();
      if (colorToMatch === "NICKEL") {
        colorToMatch = "BRUSHED NICKEL";
      }

      const variant = priceItem.types.find(t => {
        // Match using option1 field (color field) with case-insensitive comparison
        return (
          (t.option1 && t.option1.toUpperCase().trim() === colorToMatch) ||
          (t.option2 && t.option2.toUpperCase().trim() === colorToMatch) ||
          (t.option3 && t.option3.toUpperCase().trim() === colorToMatch)
        );
      });
      console.log("hardware variant", variant, "colorToMatch", colorToMatch);
      if (!variant) {
        console.error(
          "Variant not found for hardware color:",
          colorToMatch,
          "original:",
          this.tower.hardwareSetting.selectedColor
        );
        return;
      }
      // Hardware comes in packs of 1
      // 1 door = 1 piece = 1 pack
      // 2 doors = 2 pieces = 2 packs
      // 4 doors = 4 pieces = 4 packs
      const numHardwarePieces = doorObject.hardwarePositionsX.length;
      const numPacks = numHardwarePieces;
      for (let i = 0; i < numPacks; i++) {
        this.variants.push(variant);
      }
      this.price = variant.price * numPacks;
      this.tower.totalPrice += this.price;
    }
  }

  add() {
    // this.doorHardwareSetting.style.display = "block";
    this.addOptionToCanvas();
  }
  remove() {
    // Only try to remove hardware if it was actually added to the canvas
    // if (this.price > 0 && this.variants.length > 0 && this.selectedType) {
    // 	try {
    document.App.removeObjectFromSelectedCabinet("doorHardware", this.towerCounter - 1);
    // 	} catch (error) {
    // 		console.log("Hardware not found on cabinet to remove:", error);
    // 	}
    // }
    // document.App.clearAllDoorHardwareForSelectedCabinet(this.towerCounter - 1);
    // this.doorHardwareSetting.style.display = "none";
    this.tower.totalPrice -= this.price;
    this.price = 0;
    this.variants = [];
  }

  // updateOptionsToWidth(width) {
  // 	let option = this.hardwareTypeOptions[0];
  // 	let displayValue = option.getAttribute("displayValue");
  // 	if (displayValue.slice(-1) == "s") {
  // 		if (+width < 22.5) {
  // 			this.setTypeOptionsToSingular();
  // 		}
  // 	} else {
  // 		if (+width > 22) {
  // 			this.setTypeOptionsToPlural();
  // 		}
  // 	}
  // }

  // setTypeOptionsToPlural() {
  // 	this.hardwareTypeOptions.forEach(option => {
  // 		let displayValue = option.querySelector("input").getAttribute("displayValue");
  // 		displayValue = displayValue + "s";
  // 		option.setAttribute("displayValue", displayValue);
  // 		option.querySelector("label").innerText = displayValue;
  // 	});
  // }
  // setTypeOptionsToSingular() {
  // 	this.hardwareTypeOptions.forEach(option => {
  // 		let displayValue = option.querySelector("input").getAttribute("displayValue");
  // 		displayValue = displayValue.slice(0, -1);
  // 		option.setAttribute("displayValue", displayValue);
  // 		option.querySelector("label").innerText = displayValue;
  // 	});
  // }
}

class DoorSetting {
  constructor(doorSetting, towerCounter, tower) {
    this.doorSetting = doorSetting;
    this.towerCounter = towerCounter;
    this.tower = tower;
    this.options = doorSetting.querySelectorAll(".mc-radio-item");
    this.selectedValueElement = doorSetting.querySelector(".mc-selected-setting");
    this.selectedValue = "none";
    this.price = 0;
    // this.doorPrices = [];
    this.variants = [];
    this.doorState = null;
    this.initDoorSetting();
    this.updateOptionsToWidth("30");
    // this.initPrice();
  }
  // initPrice() {
  // 	this.doorPrices = this.tower.pricesArray.find((priceItem) => {
  // 		return priceItem.title == "milano-door-1";
  // 	}).types;
  // }
  openDoors() {
    // console.log(
    // 	"debug open doors",
    // 	"document.App.openLeftDoor(document.cabinetsInScene[document.CabinetVars.SelectedIndex])",
    // 	document.CabinetVars.SelectedIndex
    // );
    document.App.openLeftDoor(document.cabinetsInScene[document.CabinetVars.SelectedIndex]);
    document.App.openRightDoor(document.cabinetsInScene[document.CabinetVars.SelectedIndex]);
    // Only update state if it's not already open, and only decrement hasClosedDoors if door was previously closed
    if (this.doorState !== "open") {
      const wasClosed = this.doorState === "closed";
      this.doorState = "open";
      if (wasClosed) {
        this.tower.hasClosedDoors -= 1;
      }
    }
    // this.tower.hasOpenDoors += 1;
    // document.App.openLeftDoor(document.cabinetsInScene[this.towerCounter - 1]);
    // document.App.openRightDoor(document.cabinetsInScene[this.towerCounter - 1]);
  }
  closeDoors() {
    // console.log(
    // 	"debug close doors",
    // 	"document..closeLeftDoor(document.cabinetsInScene[document.CabinetVars.SelectedIndex])",
    // 	document.CabinetVars.SelectedIndex
    // );

    document.App.closeLeftDoor(document.cabinetsInScene[document.CabinetVars.SelectedIndex]);
    document.App.closeRightDoor(document.cabinetsInScene[document.CabinetVars.SelectedIndex]);
    // Only update state if it's not already closed
    if (this.doorState !== "closed") {
      const wasOpen = this.doorState === "open";
      const wasNull = this.doorState === null;
      this.doorState = "closed";
      // Increment hasClosedDoors if door was open (transitioning from open to closed)
      // OR if doorState was null (door exists but wasn't tracked yet - should be counted)
      if (wasOpen || wasNull) {
        this.tower.hasClosedDoors += 1;
      }
    }
  }
  initDoorSetting() {
    this.options.forEach(option => {
      option.querySelector("input").setAttribute("name", `door-${this.towerCounter}`);
      const optionId = option.querySelector("input").getAttribute("id");
      option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
      option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
      option.addEventListener("click", () => this.addOptionToCanvas());
    });
  }

  updateOptionsToWidth(width) {
    const singleDoors = [
      "full-slab-door",
      "3q-slab-door",
      "half-slab-door",
      "bottom-half-slab-door",
      "both-half-slab-door",
    ]; //, "full-mirror-door", "full-shaker-door", '3q-shaker-door', 'half-shaker-door'
    this.options.forEach(option => {
      let value = option.querySelector("input").getAttribute("value");
      if (value != "none") {
        if (+width < 22.5) {
          if (!singleDoors.includes(value)) {
            option.style.display = "none";
          } else {
            option.style.display = "flex";
          }
        } else {
          if (!singleDoors.includes(value)) {
            option.style.display = "flex";
          } else {
            option.style.display = "none";
          }
        }
      }
    });
  }

  objects = {
    "full-slab-doors": {
      name: [`%/%W_FHD_L`, `%/%W_FHD_R`],
      variant: `alto-double-full-door-pack`,
      hardwarePositionsX: ["L", "R"],
      hardwarePositionsY: ["", ""],
    },
    "full-slab-door": {
      name: [`%/%W_FDO`],
      variant: `alto-double-full-door-pack`,
      hardwarePositionsX: ["S"],
      hardwarePositionsY: [""],
    },
    "3q-slab-doors": {
      name: [`%/%W_3QD_L`, `%/%W_3QD_R`],
      variant: `alto-3-4-door-pack`,
      hardwarePositionsX: ["L", "R"],
      hardwarePositionsY: ["", ""],
    },
    "3q-slab-door": {
      name: [`%/%W_3QD`],
      variant: `alto-3-4-door-pack`,
      hardwarePositionsX: ["S"],
      hardwarePositionsY: [""],
    },
    "half-slab-doors": {
      name: [`%/%W_HDO_L`, `%/%W_HDO_R`],
      extraName: [`%/%W_HDO_L_TOP`, `%/%W_HDO_R_TOP`],
      variant: `alto-double-half-door-pack`,
      hardwarePositionsX: ["L", "R"],
      hardwarePositionsY: ["_TOP", "_TOP"],
    },
    "half-slab-door": {
      name: [`%/%W_HDO`],
      extraName: [`%/%W_HDO_TOP`],
      variant: `alto-double-half-door-pack`,
      hardwarePositionsX: ["S"],
      hardwarePositionsY: ["_TOP"],
    },
    "bottom-half-slab-doors": {
      name: [`%/%W_HDO_L`, `%/%W_HDO_R`],
      extraName: [`%/%W_HDO_L_BOTTOM`, `%/%W_HDO_R_BOTTOM`],
      variant: `alto-double-half-door-pack`,
      offset: [-1.03, -1.03],
      hardwarePositionsX: ["L", "R"],
      hardwarePositionsY: ["", ""],
    },
    "bottom-half-slab-door": {
      name: [`%/%W_HDO`],
      extraName: [`%/%W_HDO_TOP`],
      variant: `alto-double-half-door-pack`,
      offset: [-1.03],
      hardwarePositionsX: ["S"],
      hardwarePositionsY: [""],
    },
    "both-half-slab-doors": {
      name: [`%/%W_HDO_L`, `%/%W_HDO_R`, `%/%W_HDO_L`, `%/%W_HDO_R`],
      extraName: [`%/%W_HDO_L_TOP`, `%/%W_HDO_R_TOP`, `%/%W_HDO_L_BOTTOM`, `%/%W_HDO_R_BOTTOM`],
      variants: [`alto-double-half-door-pack`, `alto-double-half-door-pack`],
      offset: [0, 0, -1.03, -1.03],
      hardwarePositionsX: ["L", "R", "L", "R"],
      hardwarePositionsY: ["_TOP", "_TOP", "", ""],
    },
    "both-half-slab-door": {
      name: [`%/%W_HDO`, `%/%W_HDO`],
      extraName: [`%/%W_HDO_TOP`, `%/%W_HDO_BOTTOM`],
      variants: [`alto-double-half-door-pack`, `alto-double-half-door-pack`],
      offset: [0, -1.03],
      hardwarePositionsX: ["S", "S"],
      hardwarePositionsY: ["_TOP", ""],
    },
    "full-mirror-doors": [],
    "full-mirror-door": [],
    "full-shaker-doors": [],
    "full-shaker-door": [],
    "3q-shaker-doors": [],
    "3q-shaker-door": [],
    "half-shaker-doors": [],
    "half-shaker-door": [],
  };

  // getObjects() {
  // 	let width = this.tower.width.selectedValue;
  // 	return {
  // 		"full-slab-doors": {
  // 			name: [`${width}/${width}W_FHD_L`, `${width}/${width}W_FHD_R`],
  // 			variant: `alto-double-full-door-pack`,
  // 		},
  // 		"full-slab-door": {
  // 			name: [`${width}/${width}W_FDO`],
  // 			variant: `alto-double-full-door-pack`,
  // 		},
  // 		"3q-slab-doors": {
  // 			name: [`${width}/${width}W_3QD_L`, `${width}/${width}W_3QD_R`],
  // 			variant: `alto-3-4-door-pack`,
  // 		},
  // 		"3q-slab-door": {
  // 			name: [`${width}/${width}W_3QD`],
  // 			variant: `alto-3-4-door-pack`,
  // 		},
  // 		"half-slab-doors": {
  // 			name: [`${width}/${width}W_HDO_L`, `${width}/${width}W_HDO_R`],
  // 			extraName: [`${width}/${width}W_HDO_L_TOP`, `${width}/${width}W_HDO_R_TOP`],
  // 			variant: `alto-double-half-door-pack`,
  // 		},
  // 		"half-slab-door": {
  // 			name: [`${width}/${width}W_HDO`],
  // 			extraName: [`${width}/${width}W_HDO_TOP`],
  // 			variant: `alto-double-half-door-pack`,
  // 		},
  // 		"bottom-half-slab-doors": {
  // 			name: [`${width}/${width}W_HDO_L`, `${width}/${width}W_HDO_R`],
  // 			extraName: [`${width}/${width}W_HDO_L_BOTTOM`, `${width}/${width}W_HDO_R_BOTTOM`],
  // 			variant: `alto-double-half-door-pack`,
  // 			offset: [-1.03, -1.03],
  // 		},
  // 		"bottom-half-slab-door": {
  // 			name: [`${width}/${width}W_HDO`],
  // 			extraName: [`${width}/${width}W_HDO_TOP`],
  // 			variant: `alto-double-half-door-pack`,
  // 			offset: [-1.03],
  // 		},
  // 		"both-half-slab-doors": {
  // 			name: [
  // 				`${width}/${width}W_HDO_L`,
  // 				`${width}/${width}W_HDO_R`,
  // 				`${width}/${width}W_HDO_L`,
  // 				`${width}/${width}W_HDO_R`,
  // 			],
  // 			extraName: [
  // 				`${width}/${width}W_HDO_L_TOP`,
  // 				`${width}/${width}W_HDO_R_TOP`,
  // 				`${width}/${width}W_HDO_L_BOTTOM`,
  // 				`${width}/${width}W_HDO_R_BOTTOM`,
  // 			],
  // 			variants: [`alto-double-half-door-pack`, `alto-double-half-door-pack`],
  // 			offset: [0, 0, -1.03, -1.03],
  // 		},
  // 		"both-half-slab-door": {
  // 			name: [`${width}/${width}W_HDO`, `${width}/${width}W_HDO`],
  // 			extraName: [`${width}/${width}W_HDO_TOP`, `${width}/${width}W_HDO_BOTTOM`],
  // 			variants: [`alto-double-half-door-pack`, `alto-double-half-door-pack`],
  // 			offset: [0, -1.03],
  // 		},
  // 		"full-mirror-doors": [],
  // 		"full-mirror-door": [],
  // 		"full-shaker-doors": [],
  // 		"full-shaker-door": [],
  // 		"3q-shaker-doors": [],
  // 		"3q-shaker-door": [],
  // 		"half-shaker-doors": [],
  // 		"half-shaker-door": [],
  // 	};
  // }

  setColor(color) {
    if (this.selectedValue !== "none") {
      this.addOptionToCanvas(true);
    }
  }
  addOptionToCanvas() {
    let width = this.tower.width.selectedValue;
    const selectedOption = this.doorSetting.querySelector(
      `input[name="door-${this.towerCounter}"]:checked`
    );
    const value = selectedOption.value;
    const displayValue = selectedOption.getAttribute("displayValue");
    this.selectedValueElement.innerText = displayValue;
    // Save old door state before updating selectedValue
    const hadDoors = this.selectedValue !== "none";
    const oldDoorState = this.doorState;

    if (this.selectedValue != "none") {
      // Only try to remove old hardware if it was actually added to the canvas
      if (this.tower.doorHardwareOptions.price > 0) {
        // let selectedHardwareType = this.tower.doorHardwareOptions.typeMap[this.tower.doorHardwareOptions.selectedType];
        // try {
        document.App.removeObjectFromSelectedCabinet("doorHardware", this.towerCounter - 1);
        // } catch (error) {
        // 	console.log("Old hardware not found on cabinet to remove:", error);
        // }
        // document.App.clearAllDoorHardwareForSelectedCabinet(this.towerCounter - 1);
      }
    }
    this.selectedValue = value;
    // const objects = this.getObjects();
    this.tower.totalPrice -= this.price;
    this.tower.totalDoors -= this.tower.hasDoors;
    this.price = 0;
    this.variants = [];
    // console.log(
    // 	"debug remove door",
    // 	"document.App.removeObjectFromSelectedCabinet('door', this.towerCounter - 1);",
    // 	this.towerCounter - 1
    // );

    // Handle old door state cleanup before removing from canvas
    // If we had a door that was closed, we need to decrement hasClosedDoors
    if (hadDoors && oldDoorState === "closed") {
      this.tower.hasClosedDoors -= 1;
    }

    document.App.removeObjectFromSelectedCabinet("door", this.towerCounter - 1);

    if (value != "none") {
      this.tower.hasDoors = 1;
      // Set new door state to closed and increment hasClosedDoors
      // (old door state was already handled above)
      this.doorState = "closed";
      this.tower.hasClosedDoors += 1;
      //do price
      if (this.objects[value].variants) {
        // Handle multiple variants
        this.objects[value].variants.forEach(v => {
          this.variants.push(
            this.tower.pricesArray
              .find(p => {
                return p.title == v;
              })
              .types.find(t => {
                return t.option1.toUpperCase() == this.tower.color && t.option2.startsWith(width);
              })
          );
          this.price += this.variants[this.variants.length - 1]?.price || 0;
        });
      } else {
        // Handle single variant (backward compatibility)
        this.variants.push(
          this.tower.pricesArray
            .find(p => {
              return p.title == this.objects[value].variant;
            })
            .types.find(t => {
              return t.option1.toUpperCase() == this.tower.color && t.option2.startsWith(width);
            })
        );
        this.price = this.variants[0]?.price || 0;
      }
      // Add doors to canvas FIRST before hardware to ensure proper order
      document.CabinetVars.SelectedIndex = this.tower.towerCounter - 1;
      this.objects[value].name.forEach((object, index) => {
        object = object.replaceAll("%", this.tower.width.selectedValue);
        let offset = this.objects[value].offset ? this.objects[value].offset[index] : 0;
        let extraName = this.objects[value].extraName
          ? this.objects[value].extraName[index].replaceAll("%", this.tower.width.selectedValue)
          : null;
        document.App.addObjectToSelectedCabinet(
          object,
          extraName || object,
          `${width}/${width}W_TOWER`,
          "door",
          offset
        );
      });
      // Add hardware AFTER doors are added to prevent timing issues
      this.tower.doorHardwareOptions.add();
      // Explicitly ensure doors are closed after adding to prevent unexpected opening
      // Note: doorState is already set to "closed" and hasClosedDoors already incremented above,
      // so closeDoors() will only animate but not change state (which is what we want)
      this.closeDoors();

      if (
        ((value.startsWith("full") ||
          value.startsWith("bottom") ||
          value.startsWith("both") ||
          value.startsWith("top & bottom")) &&
          ["four-drawers", "five-drawers", "two-drawers-and-shelf"].includes(
            this.tower.bottomOptions.selectedValue
          )) ||
        (value.startsWith("3q") &&
          ["four-drawers", "five-drawers"].includes(this.tower.bottomOptions.selectedValue))
      ) {
        this.tower.bottomOptions.selectOption("hanging");
      }
    } else {
      // Removing doors completely
      // document.App.removeObjectFromSelectedCabinet([
      // 	document.App.spaceId.LEFTDOOR,
      // 	document.App.spaceId.RIGHTDOOR,
      // ]);
      this.tower.doorHardwareOptions.remove();
      this.tower.hasDoors = 0;
      // Properly handle door state when removing doors
      // If door was closed, decrement hasClosedDoors
      // If door was open, we don't need to adjust hasClosedDoors (it wasn't counting this door)
      if (this.doorState == "closed") {
        this.tower.hasClosedDoors -= 1;
      }
      // Reset doorState to null when doors are removed
      this.doorState = null;
    }
    this.tower.totalPrice += this.price;
    this.tower.totalDoors += this.tower.hasDoors;
    disableEnableAction("doors", !this.tower.totalDoors);
  }
  selectOption(opt) {
    this.options.forEach(option => {
      const input = option.querySelector("input");
      const value = input.getAttribute("value");
      if (value == opt) {
        input.checked = true;
      }
    });
    this.addOptionToCanvas();
  }
}

class DrawerHardware {
  constructor(towerCounter, tower) {
    this.towerCounter = towerCounter;
    this.tower = tower;
    // this.hardwareTypeOptions = drawerHardwareSetting.querySelectorAll(".hardware-type");
    // this.hardwareColorOptions = drawerHardwareSetting.querySelectorAll(".hardware-color");
    // this.selectedValueElement = drawerHardwareSetting.querySelector(".mc-selected-setting");
    // this.selectedType = "pull";
    // this.selectedColor = "black";
    this.variants = [];
    this.price = 0;
    // this.initDrawerHardwareSetting();
  }

  // initDrawerHardwareSetting() {
  // 	this.hardwareTypeOptions.forEach(option => {
  // 		option.querySelector("input").setAttribute("name", `hardware-type-${this.towerCounter}`);
  // 		const optionId = option.querySelector("input").getAttribute("id");
  // 		option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
  // 		option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
  // 		option.addEventListener("click", () =>
  // 			this.setSelectedType(option.querySelector("input").getAttribute("value"))
  // 		);
  // 	});
  // 	this.hardwareColorOptions.forEach(option => {
  // 		option
  // 			.querySelector("input")
  // 			.setAttribute("name", `hardware-color-${this.towerCounter}`);
  // 		const optionId = option.querySelector("input").getAttribute("id");
  // 		option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
  // 		option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
  // 		option.addEventListener("click", () =>
  // 			this.setSelectedColor(option.querySelector("input").getAttribute("value"))
  // 		);
  // 	});
  // }
  // selectTypeOption(type) {
  // 	this.selectedType = type;
  // 	this.setDisplayedValue();
  // 	// Update hardware type radio buttons
  // 	this.hardwareTypeOptions.forEach(option => {
  // 		const input = option.querySelector("input");
  // 		const value = input.getAttribute("value");
  // 		const v = input.value;
  // 		if (value === this.selectedType) {
  // 			input.checked = true;
  // 		} else {
  // 			input.checked = false;
  // 		}
  // 	});
  // }

  // selectColorOption(color) {
  // 	this.selectedColor = color;
  // 	this.setDisplayedValue();
  // 	// Update hardware color radio buttons
  // 	this.hardwareColorOptions.forEach(option => {
  // 		const input = option.querySelector("input");
  // 		const value = input.getAttribute("value");
  // 		if (value === this.selectedColor) {
  // 			input.checked = true;
  // 		} else {
  // 			input.checked = false;
  // 		}
  // 	});
  // }

  // setDisplayedValue() {
  // 	this.selectedValueElement.innerText = `${this.selectedType.charAt(0).toUpperCase() + this.selectedType.slice(1)
  // 		} - ${this.selectedColor.charAt(0).toUpperCase() + this.selectedColor.slice(1)}`;
  // }

  setSelectedType() {
    document.App.removeObjectFromSelectedCabinet("drawerHardware", this.towerCounter - 1);
    // document.App.clearAllDrawerHardwareForSelectedCabinet(this.towerCounter - 1);
    // this.selectedType = value;
    // this.setDisplayedValue();
    this.addOptionToCanvas();
  }

  setSelectedColor() {
    document.App.removeObjectFromSelectedCabinet("drawerHardware", this.towerCounter - 1);
    // document.App.clearAllDrawerHardwareForSelectedCabinet(this.towerCounter - 1);
    // this.selectedColor = value;
    // this.setDisplayedValue();
    this.addOptionToCanvas();
  }

  options = {
    pull: "PULL_MODERN_DR",
    pulls: "PULL_MODERN_DR",
    knob: "PULL_KNOB_DR",
    knobs: "PULL_KNOB_DR",
  };

  addOptionToCanvas() {
    // Remove old hardware if it was added to the canvas
    let bottomOption = this.tower.bottomOptions.selectedValue;
    if (["four-drawers", "five-drawers", "two-drawers-and-shelf"].includes(bottomOption)) {
      // 	try {
      // 		let type =
      // 			this.selectedType.slice(-1) == "s" ? this.selectedType.slice(0, -1) : this.selectedType;
      document.App.removeObjectFromSelectedCabinet("drawerHardware", this.towerCounter - 1);
      // 	} catch (error) {
      // 		console.log("Old hardware not found to remove:", error);
      // 	}
      // document.App.clearAllDrawerHardwareForSelectedCabinet(this.towerCounter - 1);

      this.tower.totalPrice -= this.price;
      this.variants = [];
      this.price = 0;
      const priceItem = this.tower.pricesArray.find(item => {
        return ["pull", "pulls"].includes(this.tower.hardwareSetting.selectedType)
          ? item.title == "alto-modern-pull"
          : item.title == "alto-modern-knob";
      });
      if (!priceItem) {
        console.error(
          "Price item not found for hardware type:",
          this.tower.hardwareSetting.selectedType
        );
        return;
      }
      // Normalize color for matching - handle case differences
      let colorToMatch = this.tower.hardwareSetting.selectedColor.toUpperCase().trim();
      if (colorToMatch === "NICKEL") {
        colorToMatch = "BRUSHED NICKEL";
      }

      const variant = priceItem.types.find(t => {
        // Match using option1 field (color field) with case-insensitive comparison
        return (
          (t.option1 && t.option1.toUpperCase().trim() === colorToMatch) ||
          (t.option2 && t.option2.toUpperCase().trim() === colorToMatch) ||
          (t.option3 && t.option3.toUpperCase().trim() === colorToMatch)
        );
      });
      if (!variant) {
        console.error(
          "Variant not found for hardware color:",
          colorToMatch,
          "original:",
          this.tower.hardwareSetting.selectedColor
        );
        return;
      }

      let width = this.tower.width.selectedValue;
      let bottomObject = this.tower.bottomOptions.objects[bottomOption];
      let object = `${this.options[this.tower.hardwareSetting.selectedType]
        }_%${this.tower.hardwareSetting.selectedColor.toUpperCase()}`;
      bottomObject.hardwarePositions.forEach((x, index) => {
        let hardwareObject = object.replace("%", bottomObject.extraHardwarePositions[index]);
        let extraName = `${hardwareObject}_${x}`;
        document.App.addObjectToSelectedCabinet(
          hardwareObject,
          extraName,
          `${width}/${width}W_TOWER`,
          "drawerHardware"
        );
        this.variants.push(variant);
        this.price += variant.price;
      });

      this.tower.totalPrice += this.price;
    }
  }

  add() {
    // this.drawerHardwareSetting.style.display = "block";
    this.addOptionToCanvas();
  }
  remove() {
    // document.App.clearAllDrawerHardwareForSelectedCabinet(this.towerCounter - 1);
    document.App.removeObjectFromSelectedCabinet("drawerHardware", this.towerCounter - 1);
    // Only try to remove hardware if it was actually added to the canvas
    if (this.price > 0 && this.variants.length > 0 && this.selectedType) {
      try {
      } catch (error) {
        console.log("Hardware not found on cabinet to remove:", error);
      }
    }
    // this.drawerHardwareSetting.style.display = "none";
    this.tower.totalPrice -= this.price;
    this.price = 0;
    this.variants = [];
  }
}

class BottomSetting {
  constructor(bottomSetting, towerCounter, tower) {
    this.bottomSetting = bottomSetting;
    this.towerCounter = towerCounter;
    this.tower = tower;
    this.options = bottomSetting.querySelectorAll(".mc-radio-item");
    this.selectedValueElement = bottomSetting.querySelector(".mc-selected-setting");
    this.selectedValue = "none";
    this.isDefaultValue = true;
    this.price = 0;
    this.variants = [];
    this.initBottomSetting();
  }

  initBottomSetting() {
    this.options.forEach(option => {
      option.querySelector("input").setAttribute("name", `bottom-${this.towerCounter}`);
      const optionId = option.querySelector("input").getAttribute("id");
      option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
      option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
      option.addEventListener("click", () => this.addOptionToCanvas("event", true));
    });
  }

  selectOption(opt) {
    if (
      ["four-drawers", "five-drawers", "two-drawers-and-shelf", "shoe-shelves"].includes(opt) &&
      !["18", "24", "30"].includes(String(this.tower.width.selectedValue))
    ) {
      opt = "none";
    }
    // const width15options = ["none", "hanging", "two-shelves"];
    // if (
    // 	this.tower.width.selectedValue == "15" &&
    // 	!this.isDefaultValue &&
    // 	!width15options.includes(opt)
    // ) {
    // 	//when swapping for small cabinet if opt invalid set to none
    // 	opt = "none";
    // }
    // if (this.isDefaultValue && opt != "none") {
    // 	if (this.tower.width.selectedValue == "15") {
    // 		opt = "two-shelves";
    // 	} else {
    // 		opt = "four-drawers";
    // 	}
    // }
    this.options.forEach(option => {
      const input = option.querySelector("input");
      const value = input.getAttribute("value");
      // let inputValue = input.value;
      if (value == opt) {
        input.checked = true;
      }
    });
    this.addOptionToCanvas(null, true);
  }

  updateOptionsToWidth(width) {
    const tooltipMessage = "This option is available for widths 18, 24, and 30 only."; // Define the tooltip message

    this.options.forEach(option => {
      value = option.querySelector("input").getAttribute("value");
      if (
        ["four-drawers", "five-drawers", "two-drawers-and-shelf", "shoe-shelves"].includes(value)
      ) {
        if (!["18", "24", "30"].includes(String(width))) {
          // option.style.display = "none";
          option.querySelector("input").disabled = true;
          option.setAttribute("title", tooltipMessage);
          option.style.cursor = "default";
          option.querySelector("label").style.cursor = "default";
          option.querySelector("input").style.cursor = "default";
          // option.style.opacity = "0.9";
        } else {
          // option.style.display = "flex";
          option.querySelector("input").disabled = false;
          option.removeAttribute("title");
          option.style.cursor = "pointer";
          option.style.opacity = "1";
        }
      }
    });
  }

  setColor(color) {
    if (this.selectedValue !== "none") {
      this.addOptionToCanvas(null, true);
    }
  }

  objects = {
    // let width = this.tower.width.selectedValue;
    // return {
    "four-drawers": {
      name: [`%/%W_DR`, `%/%W_DR`, `%/%W_DR`, `%/%W_DR`],
      extraName: [`%/%W_DR_1`, `%/%W_DR_2`, `%/%W_DR_3`, `%/%W_DR_4`],
      variants: ["alto-drawer-kit-large-2-pack", "alto-drawer-kit-large-2-pack"], //1-color, 2-width, 3-depth=22
      condition: depth => {
        return depth.startsWith("22");
      },
      hardwarePositions: ["BOTTOM1", "BOTTOM2", "BOTTOM3", "BOTTOM4"],
      extraHardwarePositions: ["", "", "", ""],
    },
    "two-shelves": {
      name: [`%/%W_SHELF`, `%/%W_SHELF`], //add top shelf
      extraName: [`%/%W_SHELF_1`, `%/%W_SHELF_2`],
      variants: ["alto-adjustable-shelf-pack"], //color, width, depth=22
      condition: depth => {
        return depth.startsWith("22");
      },
    },
    "two-shelves-14": {
      name: [`%/%W_SHELF_DP14`, `%/%W_SHELF_DP14`], //add top shelf
      extraName: [`%/%W_SHELF_DP14_1`, `%/%W_SHELF_DP14_2`], //add top shelf
      variants: ["alto-adjustable-shelf-pack"], //color, width, depth=14
      condition: depth => {
        return depth.startsWith("14");
      },
    },
    "shoe-shelves": {
      name: [`%/%W_SS_DP14`, `%/%W_SS_DP14`, `%/%W_SS_DP14`, `%/%W_SS_DP14`],
      extraName: [`%/%W_SS_DP14_1`, `%/%W_SS_DP14_2`, `%/%W_SS_DP14_3`, `%/%W_SS_DP14_4`],
      variants: ["alto-shoe-shelf-pack"], //color, width
      offset: [-0.095, -0.095, -0.095, -0.095],
    },
    hanging: {
      name: [`%/%W_ROD_@`],
      extraName: [`%/%W_ROD_@`],
      variants: ["alto-rod-pack"], // color=chrome, width
    },
    "five-drawers": {
      name: [`%/%W_DR`, `%/%W_DR`, `%/%W_DR`, `%/%W_DR_S`, `%/%W_DR_S`],
      extraName: [`%/%W_DR_1`, `%/%W_DR_2`, `%/%W_DR_3`, `%/%W_DR_S_1`, `%/%W_DR_S_2`],
      variants: [
        "alto-drawer-kit-large-2-pack",
        "alto-drawer-kit-large-1-pack",
        "alto-drawer-kit-small",
      ],
      condition: depth => {
        return depth.startsWith("22");
      },
      hardwarePositions: ["BOTTOM1", "BOTTOM2", "BOTTOM3", "BOTTOM1", "BOTTOM2"],
      extraHardwarePositions: ["", "", "", "M_", "M_"],
    },
    "two-drawers-and-shelf": {
      name: [`%/%W_DR`, `%/%W_DR`, `%/%W_SHELF`, `%/%W_SHELF`], //add drawer and shelf
      extraName: [`%/%W_DR_1`, `%/%W_DR_2`, `%/%W_SHELF`, `%/%W_SHELF_2`], //add drawer and shelf
      variants: ["alto-drawer-kit-large-2-pack", "alto-adjustable-shelf-pack"], //add
      offset: [0, 0, 0.07, 0.1],
      condition: depth => {
        return depth.startsWith("22");
      },
      hardwarePositions: ["BOTTOM1", "BOTTOM2"],
      extraHardwarePositions: ["", ""],
    },
  };
  // }

  addOptionToCanvas(event, clear = false) {
    let width = this.tower.width.selectedValue;
    if (event == "event") {
      this.isDefaultValue = false;
    }
    const selectedOption = this.bottomSetting.querySelector(
      `input[name="bottom-${this.towerCounter}"]:checked`
    );
    const value = selectedOption.value;
    const previousValue = this.selectedValue;
    const displayValue = selectedOption.getAttribute("displayValue");
    this.selectedValueElement.innerText = displayValue;
    this.selectedValue = value;

    // const objects = this.getObjects();

    this.tower.totalPrice -= this.price;
    this.price = 0;
    this.variants = [];
    // clear &&
    document.App.removeObjectFromSelectedCabinet("bottom", this.towerCounter - 1);
    if (value != "none") {
      this.objects[value].name.forEach((object, index) => {
        object = object.replaceAll("%", this.tower.width.selectedValue);
        object = object.replace(
          "@",
          (this.tower.hardwareSetting?.selectedColor || "CHROME").toUpperCase()
        );
        let extraName = this.objects[value].extraName
          ? this.objects[value].extraName[index]
            .replaceAll("%", this.tower.width.selectedValue)
            .replace("@", (this.tower.hardwareSetting?.selectedColor || "CHROME").toUpperCase())
          : object;
        let offset = this.objects[value].offset ? this.objects[value].offset[index] : 0;
        document.App.addObjectToSelectedCabinet(
          object,
          extraName,
          `${width}/${width}W_TOWER`,
          "bottom",
          offset
        );
      });

      this.objects[value].variants.forEach(v => {
        // For rods, use hardware color; for other items, use tower color or chrome
        let colorToMatch =
          v === "alto-rod-pack"
            ? (this.tower.hardwareSetting?.selectedColor || "CHROME").toUpperCase().trim()
            : this.tower.color.toUpperCase();
        // Normalize color for matching - handle case differences
        if (v === "alto-rod-pack" && colorToMatch === "NICKEL") {
          colorToMatch = "BRUSHED NICKEL";
        }
        const variant = this.tower.pricesArray
          .find(p => {
            return p.title == v;
          })
          ?.types.find(t => {
            return (
              (v === "alto-rod-pack"
                ? t.option1?.toUpperCase() === colorToMatch ||
                t.option2?.toUpperCase() === colorToMatch ||
                t.option3?.toUpperCase() === colorToMatch
                : ["CHROME", this.tower.color.toUpperCase()].includes(
                  t.option1?.toUpperCase() || ""
                )) &&
              t.option2?.startsWith(width) &&
              (!this.objects[value].condition || this.objects[value].condition(t.option3))
            );
          });

        // Shoe shelves are more condensed, so add 2 packs instead of 1
        const numPacks = v === "alto-shoe-shelf-pack" ? 2 : 1;
        for (let i = 0; i < numPacks; i++) {
          this.variants.push(variant);
          this.price += variant?.price || 0;
        }
      });

      // Add shoe rails for each shoe shelf (pricing only - rails are part of shoe shelf object)
      if (value === "shoe-shelves") {
        const shoeRailPriceItem = this.tower.pricesArray.find(p => p.title === "alto-shoe-rail");
        if (shoeRailPriceItem) {
          // Use hardware color for shoe rails (Chrome, Brushed Nickel, Black, Brass)
          let colorToMatch = (this.tower.hardwareSetting?.selectedColor || "CHROME")
            .toUpperCase()
            .trim();
          // Normalize color for matching - handle case differences
          if (colorToMatch === "NICKEL") {
            colorToMatch = "BRUSHED NICKEL";
          }
          // Map width to price data format (18->17, 24->23, 30->29)
          const mappedWidth = mapWidthToPriceDataWidth(width);
          let shoeRailVariant = shoeRailPriceItem.types.find(t => {
            return (
              (t.option1?.toUpperCase() === colorToMatch ||
                t.option2?.toUpperCase() === colorToMatch ||
                t.option3?.toUpperCase() === colorToMatch) &&
              t.option2?.startsWith(mappedWidth)
            );
          });
          if (!shoeRailVariant) {
            shoeRailVariant = shoeRailPriceItem.types.find(t => {
              return (
                (t.option1?.toUpperCase() === colorToMatch ||
                  t.option2?.toUpperCase() === colorToMatch ||
                  t.option3?.toUpperCase() === colorToMatch) &&
                t.option2?.startsWith(width)
              );
            });
          }
          if (shoeRailVariant) {
            // Shoe rails come in packs of 1, need 4 packs (one per shelf)
            // 4 shelves = 4 packs of shoe rails
            const shelfCount = this.objects[value].name.length;
            for (let i = 0; i < shelfCount; i++) {
              this.variants.push(shoeRailVariant);
              this.price += shoeRailVariant.price;
            }
          }
        }
      }

      if (this.tower.topOptions.selectedValue == "tall-hanging") {
        this.tower.topOptions.selectOption("short-hanging");
      }
      if (["four-drawers", "five-drawers", "two-drawers-and-shelf"].includes(value)) {
        this.tower.drawerHardwareOptions.add();
        if (
          (["four-drawers", "five-drawers"].includes(value) &&
            (this.tower.doorOptions.selectedValue.startsWith("full") ||
              this.tower.doorOptions.selectedValue.startsWith("3q") ||
              this.tower.doorOptions.selectedValue.startsWith("bottom") ||
              this.tower.doorOptions.selectedValue.startsWith("both") ||
              this.tower.doorOptions.selectedValue.startsWith("top & bottom"))) ||
          (value == "two-drawers-and-shelf" &&
            (this.tower.doorOptions.selectedValue.startsWith("full") ||
              this.tower.doorOptions.selectedValue.startsWith("bottom") ||
              this.tower.doorOptions.selectedValue.startsWith("both") ||
              this.tower.doorOptions.selectedValue.startsWith("top & bottom")))
        ) {
          this.tower.doorOptions.selectOption("none");
        }
      } else {
        this.tower.drawerHardwareOptions.remove();
      }
      if (value == "shoe-shelves" && this.tower.topOptions.selectedValue == "shoe-shelves") {
        this.tower.topOptions.selectOption("shoe-shelves");
      } else if (
        previousValue == "shoe-shelves" &&
        this.tower.topOptions.selectedValue == "shoe-shelves"
      ) {
        document.App.addObjectToSelectedCabinet(
          `${width}/${width}W_SHELF`,
          `${width}/${width}W_SHELF_MIDDLE`,
          `${width}/${width}W_TOWER`,
          "top",
          0.06
        );
      }
    } else {
      // When selecting "none", remove drawer hardware
      this.tower.drawerHardwareOptions.remove();
    }
    this.tower.totalPrice += this.price;
  }
}
class TopSetting {
  constructor(topSetting, towerCounter, tower) {
    this.topSetting = topSetting;
    this.towerCounter = towerCounter;
    this.tower = tower;
    this.options = topSetting.querySelectorAll(".mc-radio-item");
    this.selectedValueElement = topSetting.querySelector(".mc-selected-setting");
    this.selectedValue = "none";
    this.price = 0;
    this.variants = [];
    this.initTopSetting();
  }
  selectOption(opt, clear = true) {
    if (
      ["shoe-shelves", "cubbies14"].includes(opt) &&
      !["18", "24", "30"].includes(String(this.tower.width.selectedValue))
    ) {
      opt = "none";
    }

    this.options.forEach(option => {
      const input = option.querySelector("input");
      const value = input.getAttribute("value");
      if (value == opt) {
        input.checked = true;
      }
    });
    this.addOptionToCanvas(clear);
  }
  setColor(color) {
    if (this.selectedValue !== "none") {
      this.addOptionToCanvas(true);
    }
  }

  getObjects() {
    let width = this.tower.width.selectedValue;
    return {
      none: {
        name: [`${width}/${width}W_SHELF`], //depth options??
        extraName: [`${width}/${width}W_SHELF_MIDDLE`],
        offset: [0.06],
        variants: [],
      },
      // cubbies: {
      // 	name: [`${width}/${width}W_SHELF`, `${width}/${width}W_CUBBY`],
      //     extraName: [`${width}/${width}W_SHELF_MIDDLE`, `${width}/${width}W_CUBBY`],
      // 	variants: ['alto-cubby-insert-kit'],
      // },
      cubbies14: {
        name: [`${width}/${width}W_SHELF`, `${width}/${width}W_CUBBY_DP14`], //add top
        extraName: [`${width}/${width}W_SHELF_MIDDLE`, `${width}/${width}W_CUBBY_DP14`],
        offset: [0.06, 0],
        variants: ["alto-cubby-insert-kit"],
      },
      "two-shelves": {
        name: [`${width}/${width}W_SHELF`, `${width}/${width}W_SHELF`, `${width}/${width}W_SHELF`], //last is for top shelf
        extraName: [
          `${width}/${width}W_SHELF_MIDDLE`,
          `${width}/${width}W_SHELF`,
          `${width}/${width}W_SHELF_2`,
        ], //the divider and shelves don't work simultaneounsly
        variants: ["alto-adjustable-shelf-pack"],
        offset: [0.06, 0, 0],
        condition: depth => {
          return depth.startsWith("22");
        },
      },
      "two-shelves-14": {
        name: [
          `${width}/${width}W_SHELF`,
          `${width}/${width}W_SHELF_DP14`,
          `${width}/${width}W_SHELF_DP14`,
        ], //top is missing
        extraName: [
          `${width}/${width}W_SHELF_MIDDLE`,
          `${width}/${width}W_SHELF_DP14_1`,
          `${width}/${width}W_SHELF_DP14_2`,
        ],
        variants: ["alto-adjustable-shelf-pack"],
        offset: [0.06, 0, 0],
        condition: depth => {
          return depth.startsWith("14");
        },
      },
      "tall-hanging": {
        name: [`${width}/${width}W_SHELF`, `${width}/${width}W_ROD_@`],
        extraName: [`${width}/${width}W_SHELF_3`, `${width}/${width}W_ROD_@`],
        offset: [0, -0.04],
        variants: ["alto-rod-pack"],
      },
      "short-hanging": {
        name: [`${width}/${width}W_SHELF`, `${width}/${width}W_ROD_@`],
        extraName: [`${width}/${width}W_SHELF_MIDDLE`, `${width}/${width}W_ROD_@`],
        offset: [0.06, 0],
        variants: ["alto-rod-pack"],
      },
      "shoe-shelves": {
        name: [
          `${width}/${width}W_SHELF`,
          `${width}/${width}W_SS_DP14`,
          `${width}/${width}W_SS_DP14`,
          `${width}/${width}W_SS_DP14`,
          `${width}/${width}W_SS_DP14`,
        ], //add for top
        extraName: [
          `${width}/${width}W_SHELF_MIDDLE`,
          `${width}/${width}W_SS_DP14_1`,
          `${width}/${width}W_SS_DP14_2`,
          `${width}/${width}W_SS_DP14_3`,
          `${width}/${width}W_SS_DP14_4`,
        ],
        offset: [0.06, -0.095, -0.095, -0.095, -0.095],
        variants: ["alto-shoe-shelf-pack"],
      },
    };
  }

  addOptionToCanvas(clear = false) {
    let width = this.tower.width.selectedValue;
    const objects = this.getObjects();
    const selectedOption = this.topSetting.querySelector(
      `input[name="top-${this.towerCounter}"]:checked`
    );
    const value = selectedOption.value;
    const displayValue = selectedOption.getAttribute("displayValue");
    this.selectedValueElement.innerText = displayValue;
    this.selectedValue = value;

    if (value == "tall-hanging") {
      //clear bottom
      this.tower.bottomOptions.isDefaultValue = false;
      this.tower.bottomOptions.selectOption("none");
    }
    let skipDivider = false;
    if (value == "shoe-shelves" && this.tower.bottomOptions.selectedValue == "shoe-shelves") {
      skipDivider = true;
    }
    //clear &&
    document.App.removeObjectFromSelectedCabinet("top", this.towerCounter - 1);
    objects[value].name.forEach((object, index) => {
      if (!skipDivider || (skipDivider && object != `${width}/${width}W_SHELF`)) {
        let offset = objects[value].offset ? objects[value].offset[index] : 0;
        object = object.replace(
          "@",
          (this.tower.hardwareSetting?.selectedColor || "CHROME").toUpperCase()
        );
        document.App.addObjectToSelectedCabinet(
          object.toUpperCase(),
          objects[value].extraName[index].toUpperCase(),
          `${width}/${width}W_TOWER`,
          "top",
          offset
        );
      }
    });

    this.tower.totalPrice -= this.price;
    this.price = 0;
    this.variants = [];

    if (value != "none") {
      //map pricing
      objects[value].variants.forEach(v => {
        // For rods, use hardware color; for other items, use tower color or chrome
        let colorToMatch =
          v === "alto-rod-pack"
            ? (this.tower.hardwareSetting?.selectedColor || "CHROME").toUpperCase().trim()
            : this.tower.color.toUpperCase();
        // Normalize color for matching - handle case differences
        if (v === "alto-rod-pack" && colorToMatch === "NICKEL") {
          colorToMatch = "BRUSHED NICKEL";
        }
        const variant = this.tower.pricesArray
          .find(p => {
            return p.title == v;
          })
          ?.types.find(t => {
            return (
              (v === "alto-rod-pack"
                ? t.option1?.toUpperCase() === colorToMatch ||
                t.option2?.toUpperCase() === colorToMatch ||
                t.option3?.toUpperCase() === colorToMatch
                : [this.tower.color.toUpperCase(), "CHROME"].includes(
                  t.option1?.toUpperCase() || ""
                )) &&
              t.option2?.startsWith(width) &&
              (!objects[value].condition || objects[value].condition(t.option3))
            );
          });

        // Shoe shelves are more condensed, so add 2 packs instead of 1
        const numPacks = v === "alto-shoe-shelf-pack" ? 2 : 1;
        for (let i = 0; i < numPacks; i++) {
          this.variants.push(variant);
          this.price += variant?.price || 0;
        }
      });

      // Add shoe rails for each shoe shelf (pricing only - rails are part of shoe shelf object)
      if (value === "shoe-shelves") {
        const shoeRailPriceItem = this.tower.pricesArray.find(p => p.title === "alto-shoe-rail");
        if (shoeRailPriceItem) {
          // Use hardware color for shoe rails (Chrome, Brushed Nickel, Black, Brass)
          let colorToMatch = (this.tower.hardwareSetting?.selectedColor || "CHROME")
            .toUpperCase()
            .trim();
          // Normalize color for matching - handle case differences
          if (colorToMatch === "NICKEL") {
            colorToMatch = "BRUSHED NICKEL";
          }
          // Map width to price data format (18->17, 24->23, 30->29)
          const mappedWidth = mapWidthToPriceDataWidth(width);
          let shoeRailVariant = shoeRailPriceItem.types.find(t => {
            return (
              (t.option1?.toUpperCase() === colorToMatch ||
                t.option2?.toUpperCase() === colorToMatch ||
                t.option3?.toUpperCase() === colorToMatch) &&
              t.option2?.startsWith(mappedWidth)
            );
          });
          if (!shoeRailVariant) {
            shoeRailVariant = shoeRailPriceItem.types.find(t => {
              return (
                (t.option1?.toUpperCase() === colorToMatch ||
                  t.option2?.toUpperCase() === colorToMatch ||
                  t.option3?.toUpperCase() === colorToMatch) &&
                t.option2?.startsWith(width)
              );
            });
          }
          if (shoeRailVariant) {
            // Count only the actual shoe shelves (SS_DP14 objects), skip the divider
            let shoeShelfCount = 0;
            for (let i = 0; i < objects[value].name.length; i++) {
              if (objects[value].name[i].includes("SS_DP14")) {
                shoeShelfCount++;
              }
            }
            // Shoe rails come in packs of 1, need 4 packs (one per shelf)
            // Add one pack per shoe shelf
            for (let i = 0; i < shoeShelfCount; i++) {
              this.variants.push(shoeRailVariant);
              this.price += shoeRailVariant.price;
            }
          }
        }
      }
    }
    this.tower.totalPrice += this.price;
  }

  updateOptionsToWidth(width) {
    this.options.forEach(option => {
      if (
        ["shoe-shelves", "cubbies14"].includes(option.querySelector("input").getAttribute("value"))
      ) {
        if (["18", "24", "30"].includes(String(width))) {
          option.style.display = "flex";
        } else {
          option.style.display = "none";
        }
      }
    });
  }
  initTopSetting() {
    let _this = this;
    this.options.forEach(option => {
      option.querySelector("input").setAttribute("name", `top-${this.towerCounter}`);
      const optionId = option.querySelector("input").getAttribute("id");
      option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
      option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
      option.addEventListener("click", () =>
        this.addOptionToCanvas(this.tower.width.selectedValue, true)
      );
    });
  }
}

class WidthSetting {
  constructor(widthSetting, tower) {
    this.tower = tower;
    this.widthOptions = widthSetting.querySelectorAll(".mc-width-option");
    // this.width30option = this.widthOptions[0];
    // this.width15option = this.widthOptions[1];
    this.selectedValueElement = widthSetting.querySelector(".mc-selected-setting");
    this.selectedValue = "30";
    this.widthFixed = false;
    this.initWidthSetting();
  }

  handleWidthClicked(width) {
    if (
      ["18", "24", "30"].includes(this.selectedValue) &&
      !["18", "24", "30"].includes(width) &&
      ["four-drawers", "five-drawers", "two-drawers-and-shelf"].includes(
        this.tower.bottomOptions.selectedValue
      )
    ) {
      showPopupPromise("verra-width-confirm-popup").then(() => {
        this.selectWidth(width);
      });
    } else {
      this.selectWidth(width);
    }
  }

  selectWidth(width) {
    if (this.widthFixed) {
      editWidth(this.tower.towerCounter, width);
    } else {
      // console.log("selectwidth", width, this.widthFixed);
      const topOption = this.tower.topOptions.selectedValue;
      const bottomOption = this.tower.bottomOptions.selectedValue;
      let doorOption = this.tower.doorOptions.selectedValue;
      // console.log("save options", topOption, bottomOption, doorOption);
      this.tower.topOptions.selectOption("none");
      this.tower.bottomOptions.selectOption("none");
      this.tower.doorOptions.selectOption("none");
      // console.log(
      // 	"set options to none",
      // 	this.tower.topOptions.selectedValue,
      // 	this.tower.bottomOptions.selectedValue
      // );
      // document.App.removeObjectFromSelectedCabinet([
      // 	document.App.spaceId.MIDDLE,
      // ]);
      // console.log("cleared divider");
      //if first readd else removelastcabinet and then add
      this.widthOptions.forEach(widthOption => {
        widthOption.classList.remove("mc-width-active");
        if (widthOption.innerText.startsWith(width)) {
          widthOption.classList.add("mc-width-active");
        }
      });
      this.selectedValueElement.innerText = width + "'' Wide";
      this.selectedValue = String(width);
      let towerName = `${width}/${width}W_TOWER`;
      if (this.tower.towerCounter == 1) {
        document.App.addBigWardrobeToScene(towerName, document.App.positions[towerName]);
      } else {
        document.App.removeObjectFromSelectedCabinet("top", this.tower.towerCounter - 1);
        document.App.removeLastCabinet();
        document.App.addAdditionalCabinet(towerName); //new
      }

      // console.log("new width", this.selectedValue);
      this.tower.updateOptionsToWidth(this.selectedValue);
      this.tower.topOptions.updateOptionsToWidth(this.selectedValue);
      this.tower.bottomOptions.updateOptionsToWidth(this.selectedValue);
      this.tower.doorOptions.updateOptionsToWidth(this.selectedValue);
      this.tower.bottomOptions.selectOption(bottomOption);
      this.tower.topOptions.selectOption(topOption);
      if (doorOption != "none") {
        if (doorOption.slice(-1) == "s") {
          if (+width < 22.5) {
            doorOption = doorOption.slice(0, -1);
          }
        } else {
          if (+width > 22) {
            doorOption = doorOption + "s";
          }
        }
      }
      this.tower.doorOptions.selectOption(doorOption);
      doorOption != "none" && this.tower.doorOptions.openDoors();
      // doorOption != "none" && ;
      // if (doorOption != "none") {
      // 	setTimeout(() => this.tower.doorOptions.openDoors(), 50)
      // 	// this.tower.doorOptions.openDoors()
      // }
    }
  }

  initWidthSetting() {
    let _this = this;
    this.widthOptions.forEach(widthOption => {
      let width = widthOption.innerText;
      widthOption.addEventListener("click", function selectWidthCall() {
        // console.log("select width called", width);
        _this.handleWidthClicked(width.substring(0, width.indexOf("'")));
      });
    });
  }
}

class SettingToggle {
  constructor(setting, allSettings, tower) {
    this.allSettings = allSettings;
    this.setting = setting;
    this.tower = tower;
    this.toggleIcon = this.setting.querySelector(".mc-arrow-collapse");
    this.settingLabel = this.setting.querySelector(".mc-setting-label");
    this.settingTitle = this.settingLabel.querySelector(".mc-setting-title").innerText;
    this.settingOptions = setting.querySelector(".mc-setting-options");
    this.options = this.settingOptions.querySelectorAll(".mc-option");
    this.initSettingToggle();
  }
  initSettingToggle() {
    this.initToggleIcon();
  }
  initToggleIcon() {
    let _this = this;
    this._toggleHandler = () => _this.toggleSetting();
    this.settingLabel.addEventListener("click", this._toggleHandler);
  }

  removeEventListeners() {
    this.settingLabel.removeEventListener("click", this._toggleHandler);
  }
  minimizeSetting() {
    this.toggleIcon.classList.remove("mc-arrow-collapse-expanded");
    this.toggleIcon.classList.add("mc-arrow-collapse-minimized");
    this.settingOptions.classList.remove("mc-setting-options-expanded");
    this.settingOptions.classList.add("mc-setting-options-minimized");
    this.options.forEach(option => {
      option.classList.remove("mc-option-expanded");
      option.classList.add("mc-option-minimized");
    });
  }
  expandSetting() {
    // console.log("expand Setting", this.tower.doorOptions.selectedValue, this.settingTitle); //DOOR OPTIONS
    if (this instanceof Tower && this.tower.doorOptions.selectedValue != "none") {
      if (this.settingTitle == "DOOR OPTIONS" || this.settingTitle == "DOOR HARDWARE") {
        this.tower.doorOptions.closeDoors();
      }
      // Removed automatic door opening for other settings to prevent unexpected behavior
      // Doors should only be opened/closed explicitly by user actions
    }
    this.toggleIcon.classList.remove("mc-arrow-collapse-minimized");
    this.toggleIcon.classList.add("mc-arrow-collapse-expanded");
    this.settingOptions.classList.remove("mc-setting-options-minimized");
    this.settingOptions.classList.add("mc-setting-options-expanded");
    this.options.forEach(option => {
      option.classList.remove("mc-option-minimized");
      option.classList.add("mc-option-expanded");
    });
  }
  toggleSetting() {
    if (this.toggleIcon.classList.contains("mc-arrow-collapse-expanded")) {
      this.minimizeSetting();
    } else {
      this.allSettings.forEach(setting => {
        if (setting !== this) {
          setting.minimizeSetting();
        }
      });
      this.expandSetting();
    }
  }
}
